<template>
  <div>
    <a-table :scroll="{ x: 1300 }" :pagination="false" :columns="columns" :data-source="tableData" :loading="loading" row-key="id">
      <span slot="name" slot-scope="text, record">
        <a-tooltip placement="top" :title="record.name">
          <a class="custom-link" @click="onDetail(record)"> {{ record.name }} </a>
        </a-tooltip>
      </span>
      <span slot="priority" slot-scope="text, record">
        <span v-if="record.priority !== null && record.priority !== undefined"> {{ casePrioritys[record.priority].label }} </span>
        <span v-else>--</span>
      </span>
      <span slot="status" slot-scope="text, record">
        <span v-if="record.status">{{ caseStatus[record.status].label }}</span>
        <span v-else>--</span>
      </span>
      <span slot="tags" slot-scope="text, record">
        <a-popover placement="topLeft">
          <template slot="content">
            <a-tag v-for="(tag, index) in record.tags" :key="index" color="blue">{{ tag.name }}</a-tag>
          </template>
          <template slot="title">
            <span>用例标签</span>
          </template>
          <a-tag v-for="(tag, index) in record.tags" :key="index" color="blue">{{ tag.name }}</a-tag>
        </a-popover>
      </span>
      <span slot="creator" slot-scope="text, record">{{ getUser(record.creator) }}</span>
    </a-table>
    <case-detail :display="detailVisible" :case-id="caseId" @close="close" />
  </div>
</template>
<script>
import { caseStatus, casePrioritys } from '@/utils/dictionary';
import CaseDetail from '@/pages/project/case/components/CaseDetail';

const columns = [
  {
    key: 'selection-column',
    align: 'center',
    width: 30
  },
  {
    title: 'ID',
    dataIndex: 'key',
    key: 'key',
    width: 80,
    ellipsis: true
  },
  {
    title: '名称',
    width: 400,
    ellipsis: true,
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '优先级',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'priority' }
  },
  {
    title: '标签',
    width: 200,
    scopedSlots: { customRender: 'tags' }
  },
  {
    title: '状态',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '创建人',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'creator' }
  },
  {
    title: '创建时间',
    width: 170,
    align: 'center',
    dataIndex: 'created_time',
    key: 'created_time'
  },
  {
    title: '更新时间',
    width: 170,
    align: 'center',
    dataIndex: 'updated_time',
    key: 'updated_time'
  }
];

export default {
  components: { CaseDetail },
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      columns,
      caseStatus,
      casePrioritys,
      loading: false,
      caseId: null,
      caseData: {},
      detailVisible: false,
      projectId: parseInt(this.$route.params.project_id) || null
    };
  },
  computed: {
    getUser() {
      return user => {
        return user === null ? '--' : user.nickname;
      };
    },
    caseLink() {
      return record => {
        const route = this.$router.resolve({
          name: 'page:project:quality:case:detail',
          query: { issueId: record.id }
        });
        return route.href;
      };
    }
  },
  methods: {
    // 查看用例详情
    onDetail(record) {
      this.caseId = record.id;
      this.detailVisible = true;
      this.caseData = record;
    },

    // 关闭回调
    close() {
      this.caseId = null;
      this.caseData = {};
      this.detailVisible = false;
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .customer-filter {
  .ant-page-header {
    padding: 0;
  }
  margin-bottom: 16px;
  .ant-form-item {
    margin-bottom: 8px;
    display: flex;
    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }
  .filter-right {
    float: right;
    text-align: right;
  }
  .customer-date-picker {
    width: calc(50% - 3px);
  }
}
/deep/ .ant-table-tbody > tr > td {
  padding: 8px 8px;
}
/deep/.ant-table-thead > tr > th {
  padding: 8px 8px;
}
.handle-menu {
  margin: 0 4px;
}
.custom-link {
  color: rgba(0, 0, 0, 0.65);
}
.custom-link:hover {
  color: #1890ff;
}
.handle-button {
  margin-left: 8px;
}
</style>
